import React, {Component} from 'react';
import {Bar} from 'react-chartjs-2';
import {connect} from "react-redux";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import Typography from '@material-ui/core/Typography';
import {ROLES, withRoles} from "../Permissions";
import {actions} from "../../actions";
import {withStyles} from "@material-ui/core/styles/index";

let average = (array) => array.reduce((a, b) => Number(a) + Number(b)) / array.length;

/* takes a string phrase and breaks it into separate phrases
   no bigger than 'maxwidth', breaks are made at complete words.*/

const styles = {
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        marginTop: 10,
        marginBottom: 10
    }
};

const truncateTitle = function(str) {
    if(str.length > 35) {
        return str.slice(0,32) + '...';
    } else {
        return str
    }
}

const formatLabel = function(str, maxwidth){
    var sections = [];
    var words = str.split(" ");
    var temp = "";

    words.forEach(function(item, index){
        if(temp.length > 0)
        {
            var concat = temp + ' ' + item;

            if(concat.length > maxwidth){
                sections.push(temp);
                temp = "";
            }
            else{
                if(index == (words.length-1))
                {
                    sections.push(concat);
                    return;
                }
                else{
                    temp = concat;
                    return;
                }
            }
        }

        if(index == (words.length-1))
        {
            sections.push(item);
            return;
        }

        if(item.length < maxwidth) {
            temp = item;
        }
        else {
            sections.push(item);
        }

    });

    return sections;
}

class CriterionAvgBarChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            colors: [],
            options: {},
            criteria: '',
            indexes: []
        };
    };

    //the highest of max points from the rubric
    getMax(){
        let maxPoints = [];
        this.props.form.rubrics.map(rubric=>{
            maxPoints.push(rubric.max_points);
        })
        return Math.max.apply(null,maxPoints);
    }
    createData() {
        let labels = [];
        let datasets = [{
            label:'Average Score',
            data:[],
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: 'rgba(0,0,0,1)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(0,0,0,1)',
        }];

        let criterionObjects = [];

        this.props.form.rubrics.map((rubric)=>{
            const truncatedLabel = truncateTitle(rubric.criteria_title);
            criterionObjects.push({
                criteriaTitle:formatLabel(truncatedLabel, 10),
//                 criteriaTitle:(truncatedLabel),
                scores:[]
            });
        })

        this.props.form.reviewers.map(reviewer=>{
            reviewer.artifactScores.map((artifact)=>{
                artifact.rubricScores.map((score,index)=>{
                    if(score >= 0&&score!=null){
                        criterionObjects[index].scores.push(score);
                    }
                })
            })
        })
        console.log('criterionObjects', criterionObjects);

        const criterionLabels = criterionObjects.map(criteria=>{
            if(criteria.scores&&criteria.scores.length>0){
                const averageScore = average(criteria.scores).toFixed(2);
                datasets[0].data.push(averageScore);
            }else{
                datasets[0].data.push(null);
            }
            return criteria.criteriaTitle;
        })
        return {
            labels: criterionLabels,
            datasets: datasets
        }
    }

    componentDidMount() {
        this.setState({options: {
            responsive: false,
            legend: {
                display: false
            },
            tooltips: {
                enabled: true
            },
            scales: {
                xAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Criteria'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'Average Score'
                    },
                    ticks: {
                        beginAtZero:true,
                        //todo set the max - maybe just max of 5 as default
                        max: (this.getMax())
                    }
                }]
            }
        }});
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                <Grid item style={{paddingBottom:'25px'}}key={this.state.criteria}>
                    <Bar
                        data={this.createData()}
                        width={500}
                        height={600}
                        options={this.state.options}
                    />
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(CriterionAvgBarChart));

